module.exports = require('./helpers/bundle-url').getBundleURL('451m5') + "logo.7718c6df.svg";